var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x81\xE3\x82\xA7\xE3\x83\x83\xE3\x82\xAF\xE3\x83\x9C\xE3\x83\x83\xE3\x82\xAF\xE3\x82\xB9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5",
    cx: 8.9926,
    cy: 9,
    rx: 8.99211,
    ry: 9,
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 529",
    d: "M4.99609 8L8.49303 12L13.4886 6.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.afb6a0b3d17822d34effb2b5194971f0.svg";
export { ForwardRef as ReactComponent };